<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/hotel/topic_icon.svg" alt="" />
      <h2>Deluxe Hotels/ <br class="mo_show" />Resorts</h2>
      <p>We provide distinguished customer assurance that prevents special healing experiences from being disturbed.</p>
      <div class="topic-tags">
        <span class="tag"> #Hotels </span>
        <span class="tag"> #Resorts </span>
        <span class="tag"> #Spa </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img :src="require(`@/assets/images/location/hotel/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="" />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_trustworthiness.svg" alt="" />
            <div class="title">
              <h3>Providing Hotel Trustworthiness</h3>
            </div>
            <p class="description">Professional custom hygiene management is essential to ensure customers enjoy their stay.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_response.svg" alt="" />
            <div class="title">
              <h3>Occurrence of Customer Claims</h3>
            </div>
            <p class="description">I am worried about pests in upscale rooms and public facilities of the hotel.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_foodvirus.svg" alt="" />
            <div class="title">
              <h3>Clean and Safe Indoor Environment</h3>
            </div>
            <p class="description">I am concerned about pests entering from outside and mites breeding on chairs.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>We transform every space touched by guests into a secure and elegant environment.</h4>
            <p>
              Elevate your hotel's value and customer confidence by creating spaces that offer refined comfort, achieved through tailored hygiene
              management and scent marketing solutions.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/hotel/border_content_01.png" alt="" />
          </div>
          <div>
            <img src="@/assets/images/location/hotel/border_content_02.png" alt="" />
          </div>
          <div class="border-content">
            <h4>Experience CESCO’s scientific approach to hygiene management at every point of customer and staff movement.</h4>
            <p>
              CESCO customizes hygiene services to align with the unique characteristics of each pathway, providing peace of mind with a 24-hour
              sterilization system from the entrance to guest facilities, rooms, and bathrooms.
            </p>
          </div>
          <div class="border-content">
            <h4>We deliver specialized training and consulting to avert customer complaints.</h4>
            <p>
              Leveraging a nationwide network, CESCO promptly addresses and minimizes customer complaints through quick resolutions and distinctive
              consulting, including bedbug and mite care, regular pest control adapted to each area, and detailed reports on claims.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/hotel/border_content_03.png" alt="" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" alt="" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Deluxe Hotels/Resorts
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_food.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Food Safety
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Systematic diagnostics and solutions for food safety</p>
            </div>

            <router-link to="/solution/service/food"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_01.png'),
    products: [
      {
        posX: '52.3125rem',
        posY: '10.3075rem',
        mobilePosX: '69%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_01.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_02.png'),
    products: [
      {
        posX: '11rem',
        posY: '16.5575rem',
        mobilePosX: '15%',
        mobilePosY: '54%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_02.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_03.png'),
    products: [
      {
        posX: '36.9375rem',
        posY: '19.0575rem',
        mobilePosX: '53%',
        mobilePosY: '52%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_03.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_04.png'),
    products: [
      {
        posX: '57rem',
        posY: '25.5575rem',
        mobilePosX: '75%',
        mobilePosY: '71%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_04.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_05.png'),
    products: [
      {
        posX: '23.9375rem',
        posY: '11.0575rem',
        mobilePosX: '30%',
        mobilePosY: '40%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_05.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_06.png'),
    products: [
      {
        posX: '57.625rem',
        posY: '8.5575rem',
        mobilePosX: '76%',
        mobilePosY: '25%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_02.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_07.png'),
    products: [
      {
        posX: '37.5rem',
        posY: '22.62rem',
        mobilePosX: '50%',
        mobilePosY: '60%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_06.png'),
          name: 'CESCO\nYour Fit Bidet',
          description: 'A home-use bidet that achieves 99.99% sterilization and 99.9999% antibacterial effectiveness with electrolyzed water.'
        }
      },
      {
        posX: '50.875rem',
        posY: '10.3075rem',
        mobilePosX: '69%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_07.png'),
          name: 'CESCO\nAutomatic Toilet Cleaning Sterilizer Freshgenic',
          description: 'Cleans the toilet automatically by sterilizing 99.9% of harmful bacteria and removing 99.9% of odor-causing gases.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_08.png'),
    products: [
      {
        posX: '24.5625rem',
        posY: '22.62rem',
        mobilePosX: '33%',
        mobilePosY: '67%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_08.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/hotel/background_img_09.png'),
    products: [
      {
        posX: '51.1875rem',
        posY: '5.5575rem',
        mobilePosX: '67.5%',
        mobilePosY: '20%',
        productInfo: {
          image: require('@/assets/images/location/hotel/product_img_09.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
